import React,{useState,useEffect} from 'react'
import "./BlogTopContainer.css";
import BootstrapCarousel from './BootstrapCarousel';
import BlogTopList from './BlogTopList';
import GetAPI from "../APICalls/GetAPI";
const BlogTopContainer = () => {
  const [data,setData]=useState([])
  const getBlogs=()=>{

    let environment = process.env.REACT_APP_NODE_ENV;
    let getSingleBlogApi;
        if (environment === "PRODUCTION" || environment === undefined) {
          getSingleBlogApi = process.env.REACT_APP_PROD_BLOGAPI;
        } else {
          getSingleBlogApi = process.env.REACT_APP_DEV_BLOGAPI;
        }
        
    GetAPI(`${getSingleBlogApi}?type=All`)
    .then((res)=>{
      if (res.data.statusCode === 200) {
        setData(res.data.body);
    }
  })
    .catch(err=>{
      console.log(err)
    })
  }
useEffect(()=>{
  getBlogs()
},[])
return (
    <div className='blog-top-container'>
        <div className='blog-top-container-wrapper'>
        <BootstrapCarousel data={data}/>
        <BlogTopList data={data}/>
    </div>
    </div>
  )
}
  
export default BlogTopContainer